import { fetcher } from "helpers/fetcher";

import { TCheckAssignmentMemberReq, TCheckAssignmentMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const checkAssignmentMember = async (
  payload: TCheckAssignmentMemberReq
) => {
  return await fetcher<TCheckAssignmentMemberRes, TCheckAssignmentMemberReq>(
    ENDPOINT.BU.CHECK_ASSIGNMENT_MEMBER,
    {
      params: payload.params,
      headers: {
        [API_HEADER.BU_ID]: payload.buId || "",
      },
    }
  );
};

export const mutationCheckAssignmentMember = async (
  payload: TCheckAssignmentMemberReq
) => {
  return (await checkAssignmentMember(payload)).data;
};

mutationCheckAssignmentMember._key = (payload: TCheckAssignmentMemberReq) => [
  ENDPOINT.BU.CHECK_ASSIGNMENT_MEMBER.url,
  payload,
];
